import { render, staticRenderFns } from "./MigrationDetails.vue?vue&type=template&id=f1db0fc4&"
import script from "./MigrationDetails.vue?vue&type=script&lang=js&"
export * from "./MigrationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1db0fc4')) {
      api.createRecord('f1db0fc4', component.options)
    } else {
      api.reload('f1db0fc4', component.options)
    }
    module.hot.accept("./MigrationDetails.vue?vue&type=template&id=f1db0fc4&", function () {
      api.rerender('f1db0fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/MigrationDetails.vue"
export default component.exports